import { useMutation, useQueryClient } from '@tanstack/react-query'

import { dataOrThrow, type PatchPetBody } from '@snootsvet/shared/portal'

import { usePortalApi } from '@/customer/hooks/use-api'
import { meQueryKey } from '@/customer/hooks/use-get-me'

/**
 * Partial update of one of the signed-in member's pets via
 * `PATCH /api/portal/pets/:id`. Invalidates the `/portal/me` snapshot
 * on success so the updated pet flows back through downstream reads
 * (pets index, edit page display values, etc.) without a manual
 * refetch.
 */
export function useUpdatePet(patientId: string) {
  const api = usePortalApi()
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (body: PatchPetBody) =>
      dataOrThrow(await api.patch('/pets/:id', { params: { id: patientId }, body })),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: meQueryKey })
    },
  })
}
